var map = {
	"./i/images/writing.jpeg": "0676",
	"./ii/images/writing.jpeg": "0dd7",
	"./iii/images/writing.jpeg": "fa48",
	"./iv/images/writing.jpeg": "eb1a",
	"./v/images/writing.jpeg": "dc47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8c5";